import React, { useState, useEffect } from 'react';
import { MultiCombobox } from '../combobox';
import { TenantPageEntrySupportDto } from '@src/core/api/TenantClient';
import { injectTSDI } from '@core/tsdi';
import { Api } from '@core/api';

interface TenantMultiSelectProps {
    value: TenantPageEntrySupportDto[];
    onChange: (tenants: TenantPageEntrySupportDto[]) => void;
}

export const TenantMultiSelect = ({
    value,
    onChange
}: TenantMultiSelectProps) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [options, setOptions] = useState<TenantPageEntrySupportDto[]>([]);
    const [loading, setLoading] = useState(false);

    const { tenantClient } = injectTSDI(Api);

    // Debounced search
    useEffect(() => {
        const handler = setTimeout(() => {
            if (searchTerm) {
                fetchTenants(searchTerm);
            } else {
                setOptions([]);
            }
        }, 300);

        return () => clearTimeout(handler);
    }, [searchTerm]);

    const fetchTenants = async (search: string) => {
        setLoading(true);
        try {
            const response =
                await tenantClient.admin.tenantAdminControllerGetTenants({
                    search
                });
            setOptions(response.data.content);
        } catch (error) {
            console.error('Failed to fetch tenants:', error);
            setOptions([]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <MultiCombobox
            label="Search tenants"
            placeholder="Type to search..."
            searchPlaceholder="Type to search..."
            options={options}
            value={value}
            onChange={onChange}
            onInputChange={setSearchTerm}
            getOptionLabel={(option) => option.name}
            getOptionKey={(option) => option.name}
            loading={loading}
            renderOption={(option) => (
                <div>
                    <p className="text-sm font-semibold">{option.name}</p>
                    <p className="text-xs text-muted-foreground">
                        {option.type}
                    </p>
                </div>
            )}
        />
    );
};
